import { useQuery } from '../use-query';
import { inventoryService } from '../../services';

export const useInventoryQuery = (keys: any = {}) => {
  return useQuery(
    ['inventorys', JSON.stringify(keys)],
    () => {
      const params = { ...keys, selectYardData: true };

      return inventoryService
        .getAll({
          params,
        })
        .then((res) => res.data);
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};
